import { sortBySequence } from "./riskReviewFormUtils";

const SKIPPED_INPUT_TYPES = new Set([
  "READ_ONLY",
  "CALCULATED",
  "FILE_UPLOAD",
  "EXCEL_UPLOAD",
  "HEADING",
  "INSTRUCTION",
  "SEPARATOR",
]);

const today = () => new Date().toISOString().slice(0, 10);

const nowForDateTimeLocal = () => {
  const date = new Date();
  date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
  return date.toISOString().slice(0, 16);
};

const firstActiveOption = (field) =>
  (field.options || []).find((option) => option.active !== false);

const activeOptions = (field) =>
  (field.options || []).filter((option) => option.active !== false);

const textForField = (field, index) => {
  const label = String(field.label || field.code || "Field")
    .replace(/\s*[-–]\s*replace with exact source wording\.?/i, "")
    .replace(/\s*replace with exact source wording\.?/i, "")
    .trim();

  if (/email/i.test(field.code) || field.inputType === "EMAIL") return "test.user@example.com";
  if (/url|website/i.test(field.code) || field.inputType === "URL") return "https://example.com";
  if (/country/i.test(field.code)) return "India";
  if (/city|location/i.test(field.code)) return "Mumbai";
  if (/name|party|vendor|customer/i.test(field.code)) return `${label || "Test"} ${index + 1}`;
  return `Test ${label || field.code || index + 1}`;
};

const nonRiskBooleanValue = (field) => {
  const triggerValue = field.riskConfig?.triggerValue;
  if (typeof triggerValue === "boolean") return !triggerValue;
  return true;
};

const dummyValueForField = (field, index) => {
  switch (field.inputType) {
    case "TEXT":
    case "TEXTAREA":
    case "AUTOCOMPLETE":
    case "VALUE_HELP":
    case "EMAIL":
    case "URL":
      return textForField(field, index);
    case "NUMBER":
      return 10 + index;
    case "DECIMAL":
      return Number((12.5 + index).toFixed(2));
    case "CURRENCY":
      return 100000 + index * 5000;
    case "PERCENTAGE":
      return 10;
    case "DATE":
      return today();
    case "DATETIME":
      return nowForDateTimeLocal();
    case "CHECKBOX":
    case "YES_NO":
    case "QUESTION_YES_NO":
      return nonRiskBooleanValue(field);
    case "SELECT":
    case "RADIO":
    case "QUESTION_SELECT":
      return firstActiveOption(field)?.value ?? "";
    case "MULTI_SELECT":
      return activeOptions(field)
        .slice(0, 2)
        .map((option) => option.value);
    default:
      return undefined;
  }
};

export const buildRiskReviewDummyValues = ({ template, visibility = {} }) => {
  const fields = sortBySequence(template?.sections || []).flatMap((section) =>
    sortBySequence(section.fields || []),
  );

  return fields.reduce((values, field, index) => {
    if (!field?.code) return values;
    if (field.readOnly || SKIPPED_INPUT_TYPES.has(field.inputType)) return values;
    if (visibility[field.code] === false) return values;

    const value = dummyValueForField(field, index);
    if (value !== undefined) values[field.code] = value;
    return values;
  }, {});
};
